<template>
    <Modal
      :show.sync="isOpen"
      :on-close="onClose"
    >
        <div>
            <h2 class="font_regular font_600 text_20">{{$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.MODAL_TITLE')}}</h2>
        </div>
        <InputCard
            :label="$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.NAME.LABEL')"
            class="llm_input_field "
        >
            <InputField
            v-model="evaluation.name"
            type="text"
            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.NAME.PLACEHOLDER')"
            :error="$v.evaluation.name.$error ? $t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.NAME.ERROR') : ''"
            @blur="$v.evaluation.name.$touch"
            />
        </InputCard>
        <InputCard
            :label="$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.PROMPT.LABEL')"
            class="llm_input_field prompt_msg"
        >
            <InputField
            v-model="evaluation.prompt"
            type="textarea"
            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.PROMPT.PLACEHOLDER')"
            :error="$v.evaluation.prompt.$error ? $t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.PROMPT.ERROR') : ''"
            @blur="$v.evaluation.prompt.$touch"
            />
        </InputCard>


        <div class="my_40">
            <woot-button
                v-if="editEvalution && editEvalution.id"
                color-scheme="primary"
                variant="solid"
                size="small"
                @click="onEditEvalution"
            >
                {{$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.BTN.EDIT')}}
            </woot-button>
            <woot-button
                v-else
                color-scheme="primary"
                variant="solid"
                size="small"
                @click="addEvalution"
            >
                {{$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.BTN.ADD')}}
            </woot-button>
        </div>

    </Modal>
</template>

<script>
import Modal from "dashboard/components/Modal.vue";
import InputField from "components/ui/inputs/InputField.vue";
import InputCard from "components/ui/inputs/InputCard.vue";
import { required, minLength, url, requiredIf } from 'vuelidate/lib/validators';

export default {
    components:{
        Modal,
        InputField,
        InputCard,
    },
    props:{
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        editEvalution: {
            type: Object,
            default: () => {},
        },
    },
    data(){
        return {
            evaluation:{
                id:"", // add before submit
                name:"",
                prompt:"",
            }
        }
    },
    watch: {
        editEvalution: {
            handler(val) {
                if (val && Object.keys(val).length > 0) {
                    this.evaluation = { ...val };
                }
            },
            immediate: true,
            deep: true
        }
    },
    validations() {
      return {
        evaluation:{
          name: {
            required,
            minLength: minLength(1)
          },
          prompt: {
            required,
            minLength: minLength(1)
          },
        },
      }
    },
    methods:{
        addEvalution(){
            this.$v.evaluation.$touch();
            if (this.$v.evaluation.$invalid) {
                console.log('Validation failed',this.$v.evaluation);
                return;
            }
            this.$emit("onAddEvalution",{...this.evaluation,id:this.generateId(this.evaluation.name)});
        },
        onEditEvalution(){
            this.$v.evaluation.$touch();
            if (this.$v.evaluation.$invalid) {
                console.log('Validation failed',this.$v.evaluation);
                return;
            }
            this.$emit("onEditEvalution",this.evaluation);
        },
        generateId(text){
           return text.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '') +  '-' + Math.random().toString(36).slice(2, 8);
        }
    },
}
</script>

<style>

</style>